// src/index.ts
import axios from "axios";
import {definePathHelper, formatUrl, request, Config} from "@js-from-routes/client";
var AxiosConfig = {
  instance: axios
};
async function unwrapResponse(response, responseAs) {
  Config.withResponse(response);
  return responseAs === "response" ? response : response.data;
}
async function fetch(args) {
  const {responseAs, ...options} = args;
  const responseType = responseAs === "response" ? void 0 : responseAs.toLowerCase();
  const config = {responseType, ...options};
  return AxiosConfig.instance.request(config).catch((error) => Config.onResponseError(error));
}
Object.assign(Config, {fetch, unwrapResponse});
export {
  AxiosConfig,
  Config,
  definePathHelper,
  formatUrl,
  request
};
